module.exports = __webpack_public_path__ + "img/home_iphone1.b28f3fe0.08592996.svg";